/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-right-button': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<path pid="0" d="M5 0h18a5 5 0 015 5v18a5 5 0 01-5 5H5a5 5 0 01-5-5V5a5 5 0 015-5zm0 1.5A3.5 3.5 0 001.5 5v18A3.5 3.5 0 005 26.5h18a3.5 3.5 0 003.5-3.5V5A3.5 3.5 0 0023 1.5H5zm11.254 9.467l-3.776 3.566 3.776 3.566a.778.778 0 11-1.068 1.13l-4.374-4.13a.778.778 0 010-1.131l4.374-4.131a.778.778 0 011.068 1.13z" _fill="#27DBBD" fill-rule="nonzero"/>'
  }
})
